import React from 'react';
import { IconInfoCircular } from '@noths/polaris-client-ribbons-design-system';

/*
  Out of stock with date label has been temporarily disabled while we investigate whether the API can return valid data.
  Code has been commented out to simplify re-adding.
 */
// import { DatePartsMap, formatDate } from '@noths/polaris-client-utils';
// import { OUT_OF_STOCK_LABEL, OUT_OF_STOCK_WITH_DATE_LABEL } from '../constants/copy';
import { Product } from 'src/types';
import { OUT_OF_STOCK_LABEL } from '../constants/copy';
import * as styles from '../styles/OutOfStock.styles';

type Props = Pick<Product, 'backInStockAt'>;

// const formatBackInStockDate = (date: string) => {
//   const { day, month, year } = formatDate(date, {
//     formatToParts: true,
//   }) as DatePartsMap;

//   return `${day.value} ${month.value} ${year.value}`;
// };

// eslint-disable-next-line
export const OutOfStock = ({ backInStockAt }: Props) => (
  <div css={styles.outOfStock}>
    <IconInfoCircular width={24} height={24} css={styles.outOfStockIcon} />
    <p css={styles.outOfStockLabel}>
      {/* {backInStockAt == null
        ? OUT_OF_STOCK_LABEL
        : OUT_OF_STOCK_WITH_DATE_LABEL.replace('{DATE}', formatBackInStockDate(backInStockAt))} */}
      {OUT_OF_STOCK_LABEL}
    </p>
  </div>
);
